import restApi from "@plannel/services/utils/rest-api";

// =============== 현재 사용자 정보 조회 ===============
const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    return null;
  }
}

// =============== 통합 API 메서드 ===============

/**
 * 사용자 알림 목록 조회
 */
const getNotifications = () => {
  const user = getCurrentUser();
  if (!user || !user.username) {
    throw new Error('User information not found');
  }

  return restApi.get(`/api/notifications/user/${user.username}`);
}

/**
 * 시스템 유지보수 알림 조회 (점검 진행 중 배너용)
 * type='maintenance' 이면서 start_ts <= now <= end_ts 인 경우에만 반환
 */
const getMaintenanceNotification = () => {
  return restApi.get('/api/notifications/system/maintenance/active');
}

/**
 * 알림 읽음 처리
 */
const markNotificationAsRead = notificationId => {
  const user = getCurrentUser();
  if (!user || !user.username) {
    throw new Error('User information not found');
  }

  const url = `/api/notifications/${notificationId}/read?userId=${encodeURIComponent(user.username)}`;
  return restApi.patch(url);
}

/**
 * 모든 알림 읽음 처리
 */
const markAllNotificationsAsRead = () => {
  const user = getCurrentUser();
  if (!user || !user.username) {
    throw new Error('User information not found');
  }
  return restApi.patch(`/api/notifications/user/${encodeURIComponent(user.username)}/read-all`);
}

/**
 * 사용자의 특정 알림 숨김 처리 (z_notification_read_status 테이블의 hidden=true)
 */
const hideNotificationForUser = notificationId => {
  const user = getCurrentUser();
  if (!user || !user.username) {
    throw new Error('User information not found');
  }

  const url = `/api/notifications/${notificationId}/user/${encodeURIComponent(user.username)}`;
  return restApi.delete(url);
}

const notificationService = {
  getCurrentUser,
  getNotifications,
  getMaintenanceNotification,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  hideNotificationForUser
};

export default notificationService;
